import {
  Acceleration,
  Breakpoints,
  TextAppearance,
  TextCustom,
  TextInput,
  TextLineHeight,
  TextSize,
  TextWeight,
} from '@vw-marketing/us-components';
import React, { useState } from 'react';
import IncentiveConstants from '../../hooks-store/incentive-store/actions/incentive-constants';
import { useStore } from '../../hooks-store/store';
import { useMaintenanceContext } from '../../hooks/use-maintenance-context';
import { useTrackingManager } from '../../hooks/use-tracking-manager';
import { StyledContainer, StyledFormDescription } from './styled';

interface MileageProps {
  lastMileage?: string | null;
  maxMileageExceeded?: boolean;
}

export const Mileage = ({
  lastMileage,
  maxMileageExceeded = false,
}: MileageProps) => {
  const { translationHandler } = useMaintenanceContext();
  const trackingManager = useTrackingManager();
  const [
    store,
    { [IncentiveConstants.UpdateStoreByFormInput]: updateStoreByFormInput },
  ] = useStore();
  const { form, formValidationError } = store;
  const { mileage: isMileageInvalid } = formValidationError;

  const [mileage, setMileage] = useState(form.mileage ?? '');

  const handleMileageChange = (event) => {
    setMileage(event.target.value);
  };

  const showError = isMileageInvalid || maxMileageExceeded;

  const formatLastMileage = (mileage: string): string => {
    const numMileage = parseInt(mileage, 10);
    return numMileage.toLocaleString('en-EN'); // Using English locale for coma as thousand separator
  };

  const errorMessage =
    maxMileageExceeded && lastMileage
      ? translationHandler('form.mileage.error.last.mileage').replace(
          'XXXk',
          formatLastMileage(lastMileage),
        )
      : translationHandler('form.mileage.error');

  return (
    <StyledContainer>
      <StyledFormDescription>
        <Acceleration />
        <TextCustom
          appearance={TextAppearance.headline200}
          style={{
            [Breakpoints.default]: {
              fontWeight: TextWeight.light,
              fontSize: TextSize.TextSize20,
              lineHeight: TextLineHeight.TextLineHeight24,
            },
            [Breakpoints.b560]: {
              fontWeight: TextWeight.light,
              fontSize: TextSize.TextSize24,
              lineHeight: TextLineHeight.TextLineHeight28,
            },
          }}
        >
          {translationHandler('form.mileage.title')}
        </TextCustom>
      </StyledFormDescription>
      <TextInput
        label={translationHandler('form.mileage.placeholder')}
        isFloating
        onChange={handleMileageChange}
        onBlur={() => {
          updateStoreByFormInput({ ...form, mileage });
        }}
        value={mileage}
        appearance={showError ? 'error' : 'default'}
        message={showError ? errorMessage : ''}
      />
    </StyledContainer>
  );
};
